import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { BreadcrumbComponent } from '@components/breadcrumb/breadcrumb.component';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { ShowForRolesDirective } from '@directives/show-for-roles.directive';
import { UploadComponent } from './upload/upload.component';

@Component({
  selector: 'app-alta-rfc-primera-vez-sin-contrasena',
  imports: [CommonModule, BackboneComponent, BreadcrumbComponent, TagModule, TabViewModule, ShowForRolesDirective, UploadComponent],
  templateUrl: './alta-rfc-primera-vez-sin-contrasena.component.html',
  styleUrl: './alta-rfc-primera-vez-sin-contrasena.component.scss',
})
export class AltaRfcPrimeraVezSinContrasenaPage {}
